import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';
class PartnerAPI extends BaseAPI {
  constructor() {
    super();
  }

  apiName = 'Business';
  controllerName = 'Partners';

  list = 'list';
  getNewPartnerCodeURL = 'get-new-partner-code';
  checkPartnerRequestURL = 'check-partner-request';
  getPartnerByEmployeeIDUrl = 'partners-by-employee';

  async getListPartnerPaging(model) {
    let request = {
      url: [this.getAPIUrl(), this.list].join('/'),
      data: model,
    };
    var res = httpClient.postAsync(request);
    return res;
  }

  async getNewPartnerCode() {
    let request = {
      url: [this.getAPIUrl(), this.getNewPartnerCodeURL].join('/'),
    };
    var res = httpClient.postAsync(request);
    return res;
  }

  //thêm hàm check partner đã phát sinh request chưa
  async checkPartnerRequest(id) {
    let request = {
      url: [this.getAPIUrl(), this.checkPartnerRequestURL, id].join('/'),
    };
    var res = httpClient.postAsync(request);
    return res;
  }

  async getPartnersByEmployeeID(id) {
    let request = {
      url: [this.getAPIUrl(), this.getPartnerByEmployeeIDUrl, id].join('/'),
    };
    var res = httpClient.getAsync(request);
    return res;
  }
}

export default new PartnerAPI();
